import './Token.scss';

import { cva, VariantProps } from 'class-variance-authority';
import classNames from 'classnames';
import { FC, PropsWithChildren } from 'react';

const baseClassName = 'ds-Token';

export const colorVariants = {
  'font-primary': `${baseClassName}--font-primary`,
  'green-1': `${baseClassName}--green-1`,
  'green-2': `${baseClassName}--green-2`,
  'green-3': `${baseClassName}--green-3`,
  'green-4': `${baseClassName}--green-4`,
  'green-5': `${baseClassName}--green-5`,
  'green-6': `${baseClassName}--green-6`,
  'green-7': `${baseClassName}--green-7`,
  'green-8': `${baseClassName}--green-8`,
  'green-9': `${baseClassName}--green-9`,
  'green-10': `${baseClassName}--green-10`,
};

const colorVariance = cva(baseClassName, {
  variants: {
    color: colorVariants,
  },
  defaultVariants: {
    color: 'font-primary',
  },
});

type TokenProps = {
  className?: string;
} & VariantProps<typeof colorVariance>;

/**
 * @deprecated Use `@payloadcms/richtext-lexical` instead.
 * This component is deprecated and retained only for supporting legacy token content.
 * The current Payload CMS rich text editor supports inline styles, which can be used to achieve similar styles.
 */
export const Token: FC<PropsWithChildren<TokenProps>> = ({
  color = 'font-primary',
  className,
  children,
}) => {
  return (
    <span className={classNames(colorVariance({ color }), className)}>
      {children}
    </span>
  );
};

export default Token;
